import React, { useContext, useState } from "react";
import { Field } from "formik";
import {
  FieldButtonGroup,
  FieldInput,
  FieldInputDecimal,
} from "../../../components";

import { yesNoOptions } from "../../../utils";
import { Form } from "react-bootstrap";

const NonPayPeriodAllocation = (props) => {
  const { fields, setFieldValue, isEdit, isSave, values, handleChange } = props;
  const resetValue = () => {
    setFieldValue(fields.isIncludeDefferals, false);
    setFieldValue(fields.isIncludePlanCompensation, false);
    setFieldValue(fields.isLastDayRule, false);
    setFieldValue(fields.isHoursRequirement, false);
    setFieldValue(fields.isNormalRetirement, false);
    setFieldValue(fields.isEarlyRetirement, false);
    setFieldValue(fields.isDeath, false);
    setFieldValue(fields.isDisability, false);
  };
  const clearField = () => {
    setFieldValue(fields.hours, null);
  };
  return (
    <>
      <div>
        <h6>Non Pay Period Allocation</h6>
        <Field
          name={"isNonPayPeriodApplicable"}
          label="Non pay period allocation applicable?"
          options={yesNoOptions}
          isRequired
          selectedValue={values["isNonPayPeriodApplicable"]}
          onChange={(value) => {
            setFieldValue("isNonPayPeriodApplicable", value);
            resetValue();
          }}
          disabled={isEdit && !isSave}
          component={FieldButtonGroup}
          size="sm"
        />
        {values[fields.isNonPayPeriodApplicable] && (
          <>
            {(values[fields.sourceCategory] === 6 ||
              values[fields.sourceCategory] === 7) && (
              <>
                <Field
                  name={fields.isIncludeDefferals}
                  label="Include deferrals made to the plan pre-match entry?"
                  options={yesNoOptions}
                  isRequired
                  selectedValue={values[fields.isIncludeDefferals]}
                  onChange={(value) => {
                    setFieldValue(fields.isIncludeDefferals, value);
                  }}
                  disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                  size="sm"
                />
                <Field
                  name={fields.isIncludePlanCompensation}
                  label="Include plan compensation earned pre-match entry?"
                  options={yesNoOptions}
                  isRequired
                  selectedValue={values[fields.isIncludePlanCompensation]}
                  onChange={(value) => {
                    setFieldValue(fields.isIncludePlanCompensation, value);
                  }}
                  disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                  size="sm"
                />
              </>
            )}
            {(values[fields.sourceCategory] === 5 ||
              values[fields.sourceCategory] === 8) && (
              <Field
                name={fields.isIncludePlanCompensation}
                label="Include plan compensation earned pre-match entry"
                options={yesNoOptions}
                isRequired
                selectedValue={values[fields.isIncludePlanCompensation]}
                onChange={(value) => {
                  setFieldValue(fields.isIncludePlanCompensation, value);
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="sm"
              />
            )}
            <h6>Ongoing allocation conditions</h6>

            <Field
              name={fields.isLastDayRule}
              label="Last day rule"
              options={yesNoOptions}
              isRequired
              selectedValue={values[fields.isLastDayRule]}
              onChange={(value) => {
                setFieldValue(fields.isLastDayRule, value);
              }}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
              size="sm"
            />
            <div className="d-flex">
              <p>
                <Field
                  name={fields.isHoursRequirement}
                  label="Hours requirement"
                  options={yesNoOptions}
                  isRequired
                  selectedValue={values[fields.isHoursRequirement]}
                  onChange={(value) => {
                    setFieldValue(fields.isHoursRequirement, value);
                    clearField();
                  }}
                  disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                  size="sm"
                />
              </p>
              {values[fields.isHoursRequirement] && (
                <p className="ml-7">
                  <Field
                    size="xs"
                    name={fields.hours}
                    label={"Hours"}
                    isRequired
                    type="number"
                    autoComplete="off"
                    value={values[fields.hours]}
                    onChange={handleChange}
                    component={FieldInputDecimal}
                    onKeyDown={(e) => {
                      if (
                        e.keyCode === 187 ||
                        e.keyCode === 107 ||
                        e.keyCode === 189 ||
                        e.keyCode === 109
                      ) {
                        e.preventDefault();
                      }
                    }}
                    min={0}
                    // isAllowNegative
                    //min={-9999}
                    max={9999.99}
                    disabled={isEdit && !isSave}
                  />
                </p>
              )}
            </div>

            {!(
              !values[fields.isLastDayRule] &&
              !values[fields.isHoursRequirement]
            ) && (
              <>
                <h6>Waivers</h6>

                {/* <Field
                  name={fields.isNormalRetirement}
                  label="Normal retirement"
                  options={yesNoOptions}
                  isRequired
                  selectedValue={values[fields.isNormalRetirement]}
                  onChange={(value) => {
                    setFieldValue(fields.isNormalRetirement, value);
                    if (value === false) {
                      setFieldValue(fields.isEarlyRetirement, false);
                    }
                  }}
                  disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                  size="sm"
                />
                <Field
                  name={fields.isEarlyRetirement}
                  label="Early retirement"
                  options={yesNoOptions}
                  isRequired
                  selectedValue={values[fields.isEarlyRetirement]}
                  onChange={(value) => {
                    setFieldValue(fields.isEarlyRetirement, value);
                  }}
                  disabled={
                    values[fields.isNormalRetirement] === false ||
                    (isEdit && !isSave)
                  }
                  component={FieldButtonGroup}
                  size="sm"
                /> */}
                <Field
                  name={fields.isDeath}
                  label="Death"
                  options={yesNoOptions}
                  isRequired
                  selectedValue={values[fields.isDeath]}
                  onChange={(value) => {
                    setFieldValue(fields.isDeath, value);
                  }}
                  disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                  size="sm"
                />
                <Field
                  name={fields.isDisability}
                  label="Disability"
                  options={yesNoOptions}
                  isRequired
                  selectedValue={values[fields.isDisability]}
                  onChange={(value) => {
                    setFieldValue(fields.isDisability, value);
                  }}
                  disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                  size="sm"
                />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default NonPayPeriodAllocation;
